import React, { useState } from "react";
import { Button, FormControl, TextField, Box, Typography, Paper,  } from '@mui/material';
import LoadingScreen from '../../../components/LoadingScreen'
import { useParams, useNavigate } from "react-router-dom";
import ApiConfig from '../../../utils/services/apiConfig'
import { useKeycloak } from '@react-keycloak/web';
import { useMountEffect } from '../../../utils/hooks';

// const LoadingScreen = ({ open }) => (
//     <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={open}>
//         <CircularProgress color="inherit" />
//     </Backdrop>
// );

function EditSite(props) {
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [, setRobots] = useState([])
  const [site, setSite] = useState({});
  const { keycloak } = useKeycloak();
  const a = new ApiConfig(keycloak)
  const apiConfig = a.api()
  const navigate = useNavigate();

  const initRetrieve = () => {
    Promise.all([
        apiConfig.fetchRobotData(0),
        apiConfig.fetchRobotSite(id)
    ]).then(results => {
        console.log(results[0])
        setRobots(results[0].RobotResponse)
        console.log(results[1])
        setSite(results[1].RobotResponse)
    }).catch(error => {
        console.error(error);
    });
  }

  useMountEffect(() => {
    initRetrieve()
  }, []);

  const handleSave = () => {
    // console.log(site)
    setLoading(true);
    Promise.all([
        apiConfig.updateRobotSite(site.Id, site),
    ]).then(results => {
        // setTimeout(() => {
        console.log(results[0])
        setLoading(false);
        navigate("/managements/site_management");
        // }, 5000);
    }).catch(error => {
        console.error(error);
    });
  }

  const handleSiteChanges = (e) => {
    const { name, value } = e.target;
    setSite(prevState => ({ ...prevState, [name]: value }));
    setSite(prevState => ({ ...prevState, "UpdatedBy": keycloak.tokenParsed?.preferred_username || "system" }));
  };

  const handleCancel = () => {
    setLoading(false)
    setRobots([])
    setSite({})
    navigate("/managements/site_management");
  }

  return (
    <Box p={2}>
    <LoadingScreen open={loading} />
      <Typography variant="h4">Edit Site {site.Site}</Typography>
      <Paper elevation={3} sx={{ p: 2, mt: 2 }}>
        <form onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
                fullWidth
                label="Site Name"
                name="Site"
                variant="outlined"
                value={site.Site}
                InputLabelProps={{ shrink: true }}
                onChange={handleSiteChanges}
                sx={{ mb: 2 }}
            />
            <TextField
                fullWidth
                label="Description"
                name="Description"
                variant="outlined"
                value={site.Description}
                InputLabelProps={{ shrink: true }}
                onChange={handleSiteChanges}
                sx={{ mb: 2 }}
            />
            <TextField
                fullWidth
                label="Level"
                name="Level"
                variant="outlined"
                value={site.Level}
                InputLabelProps={{ shrink: true }}
                onChange={handleSiteChanges}
                sx={{ mb: 2 }}
            />
          </FormControl>
          <Button variant="contained" color="primary" type="submit">
            Save
          </Button>
          <Button variant="contained" color="primary" type="button" onClick={handleCancel}>
            Cancel
          </Button>
        </form>
      </Paper>
    </Box>
  );
}

export default EditSite;
